import { InitAppMain } from "./AppMain";

module SOBRAS {
    "use strict";
    export module Application {

        export function initialize() {
            if (  (window as any).notAndroidApp !== undefined ) {
                new InitAppMain();
            }else{
                document.addEventListener('deviceready', () => {
                    new InitAppMain();
                }, false);
            }
        }
    }

    window.onload = () => {
        Application.initialize();
    }
}
